var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19659_236613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 8.00016H13.013C12.7217 7.99954 12.4381 8.09437 12.2058 8.27014C11.9734 8.44592 11.805 8.69296 11.7263 8.9735L10.1597 14.5468C10.1496 14.5814 10.1285 14.6119 10.0997 14.6335C10.0708 14.6551 10.0357 14.6668 9.99967 14.6668C9.96361 14.6668 9.92852 14.6551 9.89967 14.6335C9.87082 14.6119 9.84977 14.5814 9.83967 14.5468L6.15967 1.4535C6.14958 1.41888 6.12852 1.38847 6.09967 1.36683C6.07082 1.34519 6.03574 1.3335 5.99967 1.3335C5.96361 1.3335 5.92852 1.34519 5.89967 1.36683C5.87083 1.38847 5.84977 1.41888 5.83967 1.4535L4.27301 7.02683C4.19465 7.30627 4.02726 7.55251 3.79625 7.72817C3.56524 7.90384 3.28322 7.99933 2.99301 8.00016H1.33301",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19659_236613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIcon);
export default __webpack_public_path__ + "static/media/statusIcon.b298fbfc0e9731664f7c3c5d32cd4cad.svg";
export { ForwardRef as ReactComponent };